module.exports = __webpack_public_path__ + "media/icons/i-2-authorities-d02b62a0.png";